import { Injectable, Inject, LOCALE_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Resolve } from '@angular/router';

@Injectable()
export class TranslateResolveService implements Resolve<any> {

  constructor(
    private translate: TranslateService,
    @Inject(LOCALE_ID) private curLanguage: string
  ) { }
  resolve(route: import ('@angular/router').ActivatedRouteSnapshot, state: import ('@angular/router').RouterStateSnapshot) {
    this.translate.defaultLang = this.curLanguage;
    return this.translate.getTranslation(this.curLanguage);
  }
}
